import React from "react";
import PropTypes from "prop-types";
import {PartnerDropdownCommon} from "./";

/**
 * Partner dropdown component
 * @param {object} props props
 * @returns {Element} React Component
 * @class
 */
export const PartnerDropdown = (props) => {
  const dropdownProps = {
    componentLabel: props.componentLabel,
    defaultValue: props.defaultValue,
    visualStyle: "autoComplete",
    onChange: props.onChange,
  };

  if (props.required) {
    dropdownProps.required = props.required;
  }

  return <PartnerDropdownCommon {...dropdownProps} />;
};

PartnerDropdown.propTypes = {
  componentLabel: PropTypes.string,
  defaultValue: PropTypes.string,
  currentTeam: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};
